"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const myEmployeesVacancies_1 = require("src/modules/personalDocuments/myEmployees/store/myEmployeesVacancies");
const api_1 = require("src/api");
const debouncedMethods_1 = require("api/helper/debouncedMethods");
const queryString_1 = require("core/helpers/queryString");
const react_router_dom_1 = require("react-router-dom");
const useMyEmployeeVacancies = () => {
    const [state, dispatch] = (0, myEmployeesVacancies_1.useMyEmployeeVacanciesReducer)();
    const location = (0, react_router_dom_1.useLocation)();
    const [showVacancies, setShowVacancies] = (0, react_1.useState)(false);
    const navigatePagination = (page) => {
        getMyEmployeesVacancies({ perPage: state.meta.pagination.perPage, page }).then();
    };
    const selectPerPage = (perPage) => {
        const params = (0, queryString_1.parse)(location.search);
        dispatch({ type: 'CHANGE_PER_PAGE', payload: perPage });
        getMyEmployeesVacancies({ ...params, perPage, page: undefined }).then();
    };
    const debouncedSearch = (value) => {
        const searchParams = (0, queryString_1.parse)(location.search);
        const params = value
            ? { perPage: searchParams.perPage }
            : { page: searchParams.page };
        (0, debouncedMethods_1.debouncedOnFunc)(params, getMyEmployeesVacancies);
    };
    const getMyEmployeesVacancies = async (params) => {
        dispatch({ type: 'SEND_MY_EMPLOYEES_VACANCIES_REQUEST' });
        params.perPage = params.perPage ?? 25;
        const myEmployeesVacancies = await api_1.MyEmployeesApi.getMyEmployeesVacancies(params);
        dispatch({ type: 'DONE_MY_EMPLOYEES_VACANCIES_REQUEST', payload: myEmployeesVacancies });
    };
    (0, react_1.useEffect)(() => {
        if (showVacancies) {
            getMyEmployeesVacancies({}).then();
        }
    }, [showVacancies]);
    return {
        state,
        navigatePagination,
        selectPerPage,
        debouncedSearch,
        getMyEmployeesVacancies,
        setShowVacancies,
        showVacancies
    };
};
exports.default = useMyEmployeeVacancies;
